import { useState } from "react"
import UsersPageContent from "../components/Users/UsersPageContent"
import { UsersPageContextWrapper } from "../components/Users/UsersPageContext"

type Props = {
  showDeletedView: boolean
  heroImage: string
}

const UsersPage = ({ heroImage, showDeletedView }: Props) => {
  const [selectedUserEmail, setSelectedUserEmail] = useState<string | undefined>(undefined)

  return <UsersPageContextWrapper
    showDeletedView={showDeletedView}
    userEmail={selectedUserEmail!}
  >
    <UsersPageContent
      heroImage={heroImage}
      onUserSelect={setSelectedUserEmail}
    />
  </UsersPageContextWrapper>
}

export default UsersPage